export default "__VITE_ASSET__DEiUZFy4__"